/*
 * @Author: 唐龙 2454478395@qq.com
 * @Date: 2023-05-06 16:05:50
 * @LastEditors: 唐龙 2454478395@qq.com
 * @LastEditTime: 2023-05-06 17:33:05
 * @FilePath: \tzy-vue-pc\src\utils\request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */


import axios from 'axios'

const instance = axios.create({
    baseURL: '/api',
    timeout: 60000
})
const defaultOpt = { login: true }

function baseRequest(options) {
    // const token = store.getters.token
    const headers = options.headers || {}
    headers['content-type'] = 'application/json'
    // headers['content-type'] = 'application/x-www-form-urlencoded'
    // if (token) {
    //   // headers['X-Token'] = token
    //   options.headers = headers
    // }
    options.headers = headers
    return new Promise((resolve, reject) => {
        instance(options).then(res => {
            console.log(res, 'rwq');
            if (res.status !== 200) {
                return reject({ message: '请求失败', res })
            }
            if ([410000, 410001, 410002, 40000].indexOf(res.status) !== -1) {
                // store.dispatch('user/resetToken').then(() => {
                //   location.reload()
                // })
            } else if (res.status === 200) {
                return resolve(res.data, res)
            } else {
                return reject({ message: res.message, res })
            }
        }).catch(message => reject({ message }));
    })
}
/**
 * http 请求基础类
 * 参考文档 https://www.kancloud.cn/yunye/axios/234845
 *
 */
const request = ['post', 'put', 'patch', 'delete'].reduce((request, method) => {
    /**
     *
     * @param url string 接口地址
     * @param data object get参数
     * @param options object axios 配置项
     * @returns {AxiosPromise}
     */
    request[method] = (url, data = {}, options = {}) => {
        return baseRequest(
            Object.assign({ url, data, method }, defaultOpt, options)
        )
    }
    return request
}, {});

['get', 'head'].forEach(method => {
    /**
     *
     * @param url string 接口地址
     * @param params object get参数
     * @param options object axios 配置项
     * @returns {AxiosPromise}
     */
    request[method] = (url, params = {}, options = {}) => {
        return baseRequest(
            Object.assign({ url, params, method }, defaultOpt, options)
        )
    }
})

export default request
